export const EXCEPTIONS = {
  AccessRestricted: 'CustomExceptions.AccessRestrictedException',
  EntryExists: 'CustomExceptions.EntryExistsException',
  IdArgument: 'CustomExceptions.IdArgumentException',
  SubscriptionLimit: 'CustomExceptions.SubscriptionLimitException',
  MissingFields: 'CustomExceptions.MissingFieldsException',
};
